import Component from '@glimmer/component';

export default class BbFieldComponent extends Component {
  get classLabel() {
    return this.args.classLabel || 'cell small-12 medium-3';
  }

  get classText() {
    return this.args.classText || 'cell small-12 medium-9';
  }
}
